(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galeria-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Scroll a hash en URL ────────────────────────────── */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  /* ── Cerrar todos los popovers ───────────────────────── */
  function closeAll() {
    document.querySelectorAll('.sp-popover:not([hidden])').forEach(function (pop) {
      pop.setAttribute('hidden', '');
      var trigger = document.querySelector('[data-popover="' + pop.id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  /* ── Añadir al carrito igual que Horizon ─────────────── */
  function addToCart(variantId, btn, onSuccess) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart error');
      return res.json();
    })
    .then(function () {
      if (onSuccess) onSuccess();
      // Despachar el mismo evento que Horizon escucha internamente
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function () {
      btn.disabled = false;
    });
  }

  /* ── Inicialización por tarjeta ──────────────────────── */
  function initCard(card) {

    /* — Form de variante única — */
    var simpleForm = card.querySelector('.sp-card__form:not(.sp-popover__form)');
    if (simpleForm) {
      simpleForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = simpleForm.querySelector('input[name="id"]').value;
        var btn = simpleForm.querySelector('button[type="submit"]');
        var span = btn.querySelector('span');
        var original = span ? span.textContent : '';
        addToCart(variantId, btn, function () {
          if (span) span.textContent = '✓ Añadido';
          btn.style.background = '#1c7a4a';
          setTimeout(function () {
            if (span) span.textContent = original;
            btn.style.background = '';
            btn.disabled = false;
          }, 1400);
        });
      });
    }

    /* — Popover de variantes — */
    var trigger = card.querySelector('.sp-card__picker-trigger');
    var pop = trigger ? document.getElementById(trigger.dataset.popover) : null;

    if (trigger && pop) {

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !pop.hasAttribute('hidden');
        closeAll();
        if (isOpen) {
          pop.setAttribute('hidden', '');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          pop.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      var closeBtn = pop.querySelector('.sp-popover__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          pop.setAttribute('hidden', '');
          trigger.setAttribute('aria-expanded', 'false');
        });
      }

      pop.addEventListener('click', function (e) { e.stopPropagation(); });

      var pills = pop.querySelectorAll('.sp-pill:not(.sp-pill--sold)');
      var confirmBtn = pop.querySelector('.sp-popover__confirm');
      var confirmLabel = confirmBtn ? confirmBtn.querySelector('.sp-confirm-label') : null;
      var variantInput = pop.querySelector('.sp-popover__variant-input');
      var pickerSelected = trigger.querySelector('.sp-picker-selected');

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pop.querySelectorAll('.sp-pill').forEach(function (p) {
            p.classList.remove('sp-pill--selected');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('sp-pill--selected');
          pill.setAttribute('aria-pressed', 'true');

          var variantId = pill.dataset.variantId;
          var variantTitle = pill.dataset.variantTitle;

          if (variantInput) variantInput.value = variantId;
          if (confirmBtn) {
            confirmBtn.disabled = false;
            if (confirmLabel) confirmLabel.textContent = 'Añadir al carrito — ' + variantTitle;
          }
          if (pickerSelected) pickerSelected.textContent = '— ' + variantTitle;
        });
      });

      /* Submit del form del popover */
      var popForm = pop.querySelector('.sp-popover__form');
      if (popForm) {
        popForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var variantId = popForm.querySelector('input[name="id"]').value;
          if (!variantId) return;
          var btn = popForm.querySelector('button[type="submit"]');
          var label = btn.querySelector('.sp-confirm-label');
          var original = label ? label.textContent : '';
          addToCart(variantId, btn, function () {
            if (label) label.textContent = '✓ Añadido';
            btn.style.background = '#1c7a4a';
            setTimeout(function () {
              if (label) label.textContent = original;
              btn.style.background = '';
              btn.disabled = false;
              pop.setAttribute('hidden', '');
              trigger.setAttribute('aria-expanded', 'false');
            }, 1400);
          });
        });
      }
    }

    /* — Wishlist con localStorage — */
    var wishBtn = card.querySelector('.sp-card__wishlist');
    if (wishBtn) {
      var productId = wishBtn.dataset.id;
      var favs = JSON.parse(localStorage.getItem('sp_wishlist') || '[]');
      if (favs.includes(productId)) wishBtn.setAttribute('aria-pressed', 'true');
      wishBtn.addEventListener('click', function () {
        var pressed = wishBtn.getAttribute('aria-pressed') === 'true';
        var newState = !pressed;
        wishBtn.setAttribute('aria-pressed', String(newState));
        var list = JSON.parse(localStorage.getItem('sp_wishlist') || '[]');
        if (newState) {
          if (!list.includes(productId)) list.push(productId);
        } else {
          list = list.filter(function (id) { return id !== productId; });
        }
        localStorage.setItem('sp_wishlist', JSON.stringify(list));
      });
    }
  }

  /* ── Listeners globales ──────────────────────────────── */
  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  document.querySelectorAll('.sp-card').forEach(initCard);

  document.addEventListener('collection:products-loaded', function (e) {
    var container = e.detail && e.detail.container;
    if (container) container.querySelectorAll('.sp-card').forEach(initCard);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-busqueda-whatsapp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-sg-request-form]');
    if (!form) return;
    event.preventDefault();

    const phone = (form.dataset.phone || '').replace(/\D/g, '');
    const product = form.elements.product.value.trim();
    const reference = form.elements.reference.value.trim();
    if (!phone || !product) return;

    let message = 'Hola, soy cliente de Sports Garden. Estoy buscando: ' + product + '.';
    if (reference) message += '\nModelo / referencia: ' + reference + '.';
    message += '\n¿Me pueden ayudar a encontrarlo y confirmar disponibilidad?';

    window.location.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
  });

  } catch(e) { console.error(e); }
})();
})();
